<template>
  <hm-content>
    <div class="table-panel flex flex-between">
      <div class="mr10">
        <el-button type="primary" size="small" @click="addMember"
          >添加会员</el-button
        >
        <el-button type="primary" size="small" @click="importTempVisible = true"
          >会员导入</el-button
        >
        <el-button type="primary" size="small" @click="changeRecord"
          >查询会员变更记录</el-button
        >
      </div>
      <div class="flex-1 text-right">
        <el-cascader
          ref="cascader"
          clearable
          v-model="searchCondition.orgCode"
          :props="props"
          placeholder="请选择导购机构"
          :show-all-levels="false"
          size="small"
          class="mr10"
        ></el-cascader>
        <el-select
          clearable
          class="mr10"
          style="width: 200px"
          size="small"
          v-model="searchCondition.employeeId"
          placeholder="请输入所属导购姓名"
          filterable
        >
          <el-option
            :label="v.realname"
            :value="v.employeeId"
            :key="i"
            v-for="(v, i) in allEmployee"
          ></el-option>
        </el-select>
        <el-select
          clearable
          class="mr10"
          size="small"
          style="width: 130px"
          v-model="searchCondition.isHaveMemberCard"
          placeholder="是否有会员卡"
        >
          <el-option label="是" value="yes"></el-option>
          <el-option label="否" value="no"></el-option>
        </el-select>

        <el-select
          clearable
          class="mr10"
          size="small"
          style="width: 150px"
          v-model="searchCondition.isFriend"
          placeholder="是否有微信好友"
        >
          <el-option label="是" value="true"></el-option>
          <el-option label="否" value="false"></el-option>
        </el-select>

        <el-input
          clearable
          style="width: 300px"
          v-model.trim="searchCondition.keyword"
          :placeholder="placeholder"
          size="small"
          class="ipt mr10"
        >
          <el-select
            slot="prepend"
            size="small"
            style="width: 100px"
            @change="selectQueryType"
            v-model="searchCondition.queryType"
          >
            <el-option label="手机号" value="memberMobile"></el-option>
            <el-option label="会员名称" value="memberName"></el-option>
            <el-option label="会员卡" value="cardNo"></el-option>
          </el-select>
        </el-input>
        <el-input
          clearable
          v-model.trim="searchCondition.employeeMemberMobile"
          placeholder="请输入导购手机号"
          size="small"
          class="ipt mr10"
        ></el-input>
      </div>
    </div>
    <div class="flex flex-end">
      <el-select
        clearable
        class="mr10"
        style="width: 150px"
        size="small"
        v-model="searchCondition.isShareMember"
        placeholder="是否推会员"
        filterable
      >
        <el-option label="是" value="yes"></el-option>
        <el-option label="否" value="no"></el-option>
      </el-select>
      <el-date-picker
        clearable
        :default-time="['00:00:00', '23:59:59']"
        v-model="searchCondition.openDate"
        type="datetimerange"
        align="right"
        start-placeholder="请选择开卡时间段"
        end-placeholder="请选择开卡时间段"
        value-format="yyyy-MM-dd HH:mm:ss"
        size="small"
        class="mr10"
      >
      </el-date-picker>
      <el-date-picker
        clearable
        :default-time="['00:00:00', '23:59:59']"
        v-model="searchCondition.date"
        type="datetimerange"
        align="right"
        start-placeholder="请选择注册时间段"
        end-placeholder="请选择注册时间段"
        value-format="yyyy-MM-dd HH:mm:ss"
        size="small"
        class="mr10"
      >
      </el-date-picker>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button
        type="success"
        size="small"
        @click="output"
        :loading="isOutputing"
        >导出</el-button
      >
    </div>
    <div class="table">
      <div class="flex batch flex-between mb10 item-center">
        <div>
          <span>已选{{ num }}条</span>
        </div>
        <div class="flex flex-wrap">
          <el-button type="text" size="small" class="mr10" @click="batchAllot"
            >导表分配/解绑导购</el-button
          >
          <div @click="batchSetting" class="pointer flex item-center">
            <span class="delete-icon hmicon icon-cuxiaoguanli"></span>
            批量分配导购
          </div>
        </div>
      </div>
      <el-table
        @selection-change="getChecked"
        :data="memberMgtList.records"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="会员手机号"
          prop="memberMobile"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="客户姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sourceType"
          label="来源方式"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.sourceType == 'manual'">手工</span>
            <span v-if="scope.row.sourceType == 'synchro'">同步</span>
            <span v-if="scope.row.sourceType == 'fans'">粉丝</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="relationSpu"
          label="标签"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="是否关联会员卡"
        >
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.defaultCardId !== '-'"
              >是</span
            >
            <span class="danger" v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="关联会员卡"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.defaultCardId !== '-'"
              size="small"
              type="text"
              class="blue"
              @click="viewMemberCard(scope.row)"
              >查看会员卡</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="是否粉丝"
          prop="fansId"
        >
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.fansId">是</span>
            <span class="danger" v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="是否推会员"
          prop="isShareMember"
        >
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.isShareMember === 'yes'"
              >是</span
            >
            <span class="danger" v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="wechatCode"
          label="微信编号"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.wechatCode">{{ scope.row.wechatCode }}</span>
            <span class="blue" v-else>邀请关注</span>
          </template>
          <!-- <span class="blue">邀请关注</span> -->
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="注册时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="opencardTime"
          label="开卡时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="归属导购"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.realName"
              >{{ scope.row.shopName }} {{ scope.row.shopName ? "-" : "" }}
              {{ scope.row.realName }}</span
            >
            <div v-if="scope.row.workNum">导购工号:{{ scope.row.workNum }}</div>
            <el-button
              size="small"
              type="text"
              class="blue"
              v-if="scope.row.defaultCardId !== '-' && !scope.row.realName"
              @click="getEmployee(scope.row)"
              >指定导购</el-button
            >
          </template>
          <!-- <span class="blue">指定导购</span> -->
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="注册导购"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">            
            <div v-if="scope.row.opencardDepartName">{{ scope.row.opencardDepartName }}</div>
            <div v-if="scope.row.opencardReferName">{{ scope.row.opencardReferName }}
              <span v-if="scope.row.opencardReferWorkNum">({{ scope.row.opencardReferWorkNum }})</span>
            </div>
          </template>          
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="isFriend"
          label="是否企业微信好友"
          width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.isFriend == "true" ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="employeeMemberMobile"
          label="导购手机号"
          width="100"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="查看" placement="top">
                <div class="pointer" @click="toDetails(scope.row)">
                  <span class="hmicon icon-chakan blue"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="memberMgtList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="添加标签"
      :visible.sync="tagModalVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="添加标签">
          <el-tag
            :key="tag"
            v-for="tag in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
            >{{ tag }}</el-tag
          >
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          ></el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput"
            >+ New Tag</el-button
          >
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="tagModalVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="查看详情"
      :visible.sync="detailsModalVisible"
      width="1030px"
    >
      <ul class="info-list">
        <li class="mb20">
          <div class="title">基本信息</div>
          <div class="mb20">
            <el-table
              stripe
              border
              :data="[detMemberMgt.storeMemberCenterInfoVo]"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="memberName"
                label="姓名"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="memberMobile"
                label="手机号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="memberSex"
                label="性别"
              >
                <template slot-scope="scope">
                  <span>{{
                    scope.row.memberSex === "male" ? "男" : "女"
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="memberBirthday"
                label="生日"
              ></el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="星座"
              ></el-table-column> -->
              <el-table-column
                header-align="center"
                align="center"
                prop="nickName"
                label="微信昵称"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="isFriend"
                label="是否企业微信好友"
              >
                <template slot-scope="scope">
                  {{ scope.row.isFriend == "true" ? "是" : "否" }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="subscribeTime"
                label="关注时间"
              ></el-table-column>
            </el-table>
          </div>
          <div class="mb20">
            <el-table
              stripe
              border
              :data="detMemberMgt.familyInfoVoList"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="familyRelation"
                label="成员关系"
              >
                <template slot-scope="scope">
                  <span v-show="scope.row.familyRelation === 'son'">儿子</span>
                  <span v-show="scope.row.familyRelation === 'daughter'"
                    >女儿</span
                  >
                  <span v-show="scope.row.familyRelation === '-'"></span>
                  <span v-show="scope.row.isPredicted === 'yes'">孕期</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="familyName"
                label="姓名"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="familyBirthday"
                label="生日/预产期"
              ></el-table-column>
            </el-table>
          </div>
          <div class="mb20">
            <el-table
              stripe
              border
              :data="[detMemberMgt.storeMemberCenterInfoVo]"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="cardAddress"
                label="常用地址"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="shopName"
                label="归属门店"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="realName"
                label="归属导购"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.realName"
                    >{{ scope.row.shopName }}
                    {{ scope.row.shopName ? "-" : "" }}
                    {{ scope.row.realName }}</span
                  >
                  <div v-if="scope.row.workNum">
                    导购工号:{{ scope.row.workNum }}
                  </div>
                  <!-- <span
                    class="blue"
                    v-if="
                      scope.row.defaultCardId !== '-' && !scope.row.realName
                    "
                    @click="getEmployee(scope.row)"
                    >指定导购</span
                  > -->
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="opencardDepartName"
                label="注册门店和注册导购"
                width="200"
              >
                <template slot-scope="scope">
                  <div>
                    <div v-if="scope.row.opencardDepartName">
                      {{ scope.row.opencardDepartName }}
                    </div>
                    <div v-if="scope.row.opencardReferName">
                      {{ scope.row.opencardReferName }}
                      <span v-if="scope.row.opencardReferWorkNum">
                        ({{ scope.row.opencardReferWorkNum }})
                      </span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="来源方式"
                prop="sourceType"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.sourceType == 'manual'">手工</span>
                  <span v-if="scope.row.sourceType == 'synchro'">同步</span>
                  <span v-if="scope.row.sourceType == 'fans'">粉丝</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="授权过的小程序"
                width="200"
              >
                <template>
                  <div v-for="(v, i) in memberRecord" :key="i">
                    <span
                      :class="{ success: v.type === 2, blue: v.type === 6 }"
                      >{{ v.nickName }}</span
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </li>
        <li class="mb20">
          <div class="title">会员卡信息</div>
          <div class="flex flex-center mb20">
            <div class="text-center">
              <div class="primary mb10">
                {{
                  detMemberMgt.cardInfoVoList
                    ? detMemberMgt.cardInfoVoList.length
                    : 0
                }}
              </div>
              <div>会员卡数量</div>
            </div>
            <div class="line"></div>
            <div class="text-center pointer" @click="viewCustomerCoupon">
              <div class="primary mb10">{{ detMemberMgt.couponNum }}</div>
              <div>可用优惠券</div>
            </div>
            <div class="line"></div>
            <div class="text-center pointer" @click="viewCustomerJinDou">
              <div class="primary mb10">{{ totalGoldBeanAmount || 0 }}</div>
              <div>可用金豆</div>
            </div>
          </div>
          <el-table
            stripe
            border
            :data="detMemberMgt.cardInfoVoList"
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="typeName"
              label="会员卡类型"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="cardNo"
              label="卡号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="opencardTime"
              label="开卡时间"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="currentIntegral"
              label="积分"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="currentBalance"
              label="线下储值卡余额"
              v-if="storeCode === '36040016092873'"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="currentBalance"
              label="储值卡"
              v-else
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="totalConsumption"
              label="累计消费金额"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="firstOfflineShoppingAmount"
              label="首次消费金额"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="firstOfflineShoppingTime"
              label="首次消费时间"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="lastOfflineShoppingAmount"
              label="最后一次消费金额"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="lastOfflineShoppingTime"
              label="最后一次消费时间"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="cardState"
              label="卡状态"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.cardState == 'yes'" class="success"
                  >正常</span
                >
                <span v-else class="danger">停用</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="isMasterCard"
              label="是否默认消费卡"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.isMasterCard == 'yes'" class="success"
                  >是</span
                >
                <span v-else class="danger">否</span>
              </template>
            </el-table-column>
          </el-table>
          <div
            class="cardid"
            v-if="detMemberMgt.storeMemberCenterInfoVo.joinTime"
          >
            成为推会员时间：{{ detMemberMgt.storeMemberCenterInfoVo.joinTime }}
          </div>
          <div class="cardid" v-if="detMemberMgt.cardInfoVoList.length">
            选择默认消费卡
            <el-radio
              v-model="defaultCardId"
              :label="v.memberCardId"
              v-for="(v, i) in detMemberMgt.cardInfoVoList"
              :key="i"
              >{{v.cardNo}}【{{ v.typeName }}】</el-radio
            >
          </div>
        </li>
        <li class="mb20">
          <div class="flex flex-wrap item-center">
            <div class="title mr10">标签信息</div>
            <el-button
              size="small"
              type="text"
              @click="addLabel"
              style="marginbottom: 20px"
              >增加标签</el-button
            >
          </div>

          <template v-for="(v, i) in detMemberMgt.labelInfoVos">
            <el-tag
              v-if="detMemberMgt.labelInfoVos.length"
              style="margin: 5px"
              :key="i"
              :closable="v.labelType === 'manual'"
              @close="handleTagClose(v, i)"
            >
              {{ v.labelName }}</el-tag
            >
          </template>
        </li>
        <li class="mb20">
          <div class="title">交易统计</div>
          <el-table stripe border :data="transactionStatistics" size="small">
            <el-table-column
              header-align="center"
              align="center"
              prop="lastShoppingTime"
              label="最近下单时间"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="singlePrice"
              label="单客价"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="totalActuallyPrice"
              label="消费金额"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="orderNum"
              label="消费订单（笔）"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="refundOrderPrice"
              label="退款金额（元）"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="refundOrderNum"
              label="退款订单（笔）"
            ></el-table-column>
          </el-table>
        </li>
        <!--测试-->
        <li class="mb20">
          <div class="title mr10">操作</div>
          <div class="flex flex-wrap item-center">
            <div class="mr10">转移优惠券和金豆到新手机号</div>
            <el-input
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="changeMemberMobile"
              placeholder="请输入转移的手机号"
              maxlength="11"
            ></el-input>
          </div>
          <div class="flex flex-wrap item-center mt10">
            <div class="mr10">
              请输入<span class="primary">{{
                detMemberMgt.storeMemberCenterInfoVo.memberMobile
              }}</span
              >的验证码
            </div>
            <el-input
              size="small"
              maxlength="6"
              placeholder="请输入验证码"
              v-model.trim="authCode"
            ></el-input>
            <span v-show="!time" @click="getCode" class="primary get-code"
              >获取验证码</span
            >
            <span v-show="time" class="get-code">剩余{{ time }}s</span>
          </div>
          <div class="flex flex-wrap item-center mt10">
            <el-button size="small" type="primary" @click="memberDataMove"
              >确 认 转 移</el-button
            >
          </div>
          <div class="flex flex-wrap item-center mt10" v-if="!isBtn('member:remove')">
            <el-button size="small" type="danger" @click="removeMember"
              >删 除 会 员</el-button
            >
          </div>
        </li>
      </ul>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="detailsModalVisible = false"
          >取消</el-button
        >
        <el-button size="small" type="info" @click="logout">注 销</el-button>
      </div>
      <el-dialog
        width="30%"
        title="增加标签"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div>
          会员标签：
          <el-select
            clearable
            class="mr10"
            style="width: 200px"
            size="small"
            v-model="labelId"
            placeholder="请选择会员标签"
            filterable
          >
            <el-option
              :label="v.labelName"
              :value="v.labelId"
              :key="i"
              v-for="(v, i) in allLabelList"
            ></el-option>
          </el-select>
        </div>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button size="small" type="primary" @click="saveLabel"
            >确 定</el-button
          >
          <el-button size="small" @click="innerVisible = false">取消</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="添加会员"
      :visible.sync="setMemberDialogVisible"
      custom-class="dialog"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="product-ruleForm"
      >
        <el-form-item label="手机号：" prop="memberMobile">
          <el-input
            size="small"
            clearable
            class="mr10 ipt"
            v-model.trim="ruleForm.memberMobile"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名：" prop="memberName">
          <el-input
            size="small"
            clearable
            class="mr10 ipt"
            v-model.trim="ruleForm.memberName"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="生日：" prop="memberBirthday">
          <el-date-picker
            v-model="ruleForm.memberBirthday"
            type="date"
            :picker-options="pickerOptions"
            start-placeholder="请选择出生年月日"
            end-placeholder="报名结束时间"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="性别：">
          <el-radio-group v-model="ruleForm.memberSex">
            <el-radio label="men">男</el-radio>
            <el-radio label="women">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            size="small"
            clearable
            class="mr10 ipt"
            type="textarea"
            v-model.trim="ruleForm.memberRemark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <!-- <div class="flex item-center pointer" @click="addFamilyCase">
          <div class="add-wrapper small mr10">
            <span class="hmicon icon-hao pointer"></span>
          </div>
          <span class="primary">添加家庭档案</span>
        </div>
        <el-form-item label="预产期：" prop="dueDate" v-if="showFamilyCase">
          <div class="flex">
            <el-date-picker
              v-model="ruleForm.dueDate"
              type="date"
              :picker-options="dueDatepickerOptions"
              placeholder="请选择预产期"
              value-format="yyyy-MM-dd"
              size="small"
              class="mr10"
            ></el-date-picker>
            <div class="minus-wrapper small">
              <span
                class="hmicon icon-jianhao pointer"
                @click="deleteDute"
              ></span>
            </div>
          </div>
        </el-form-item>
        <div
          v-if="showFamilyCase"
          class="flex item-center pointer"
          @click="addBaby"
        >
          <div class="add-wrapper small mr10">
            <span class="hmicon icon-hao pointer"></span>
          </div>
          <span class="primary">添加宝宝</span>
        </div>
        <ul v-if="showFamilyCase">
          <li
            class="flex item-center"
            v-for="(v, i) in ruleForm.familyInfo"
            :key="i"
          >
            <div>
              <el-form-item label="宝宝生日：">
                <el-date-picker
                  v-model="v.familyBirthday"
                  type="date"
                  :picker-options="pickerOptions"
                  placeholder="请选择宝宝生日"
                  value-format="yyyy-MM-dd"
                  size="small"
                  class="mr10"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="宝宝姓名：">
                <el-input
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="v.familyName"
                  placeholder="请输入备注"
                ></el-input>
              </el-form-item>
              <el-form-item label="宝宝性别：">
                <el-radio-group v-model="v.familyRelation">
                  <el-radio label="son">男</el-radio>
                  <el-radio label="daughter">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="minus-wrapper small" v-if="i > 0">
              <span
                class="hmicon icon-jianhao pointer"
                @click="deleteBabyCase(i)"
              ></span>
            </div>
          </li>
        </ul> -->
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="setMemberDialogVisible = false"
            >返回</el-button
          >
        </div>
      </el-form>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="会员卡详情"
      :visible.sync="setMemberIdDialogVisible"
      custom-class="dialog"
    >
      <el-table stripe border :data="detailMember" size="small">
        <el-table-column
          header-align="center"
          align="center"
          prop="typeName"
          label="会员卡类型"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardNo"
          label="卡号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="opencardTime"
          label="开卡时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="currentIntegral"
          label="积分"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="currentBalance"
          label="储值卡"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalConsumption"
          label="累计消费金额"
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="spuName"
          label="最后一次消费时间"
        ></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="cardState"
          label="卡状态"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.cardState == 'yes'" class="success"
              >正常</span
            >
            <span v-else class="danger">停用</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="isMasterCard"
          label="是否默认消费卡"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isMasterCard == 'yes'" class="success"
              >是</span
            >
            <span v-else class="danger">否</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="批量设置"
      width="80%"
      :visible.sync="dialogVisible"
    >
      <div class="table-panel flex flex-end">
        <div>
          <el-input
            clearable
            style="width: 249px"
            size="small"
            type="text"
            placeholder="请输入导购账号/名称"
            class="mr10"
            v-model.trim="keyWords"
          ></el-input>
          <el-button type="primary" size="small" @click="searchGuider"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mb10">
        <div class="tips mb20">提示：点击表格行即可选择</div>
        <el-table
          @current-change="getCheckedEmployee"
          :data="allEmployeeList.records"
          highlight-current-row
          style="width: 100%"
          stripe
          size="small"
          border
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="
              (index) =>
                index + (currentPageEmployee - 1) * pageSizeEmployee + 1
            "
          ></el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            label="用户账号"
            prop="username"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realname"
            label="用户名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="memberMobile"
            label="手机号"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.memberMobile">
                {{ scope.row.memberMobile }}
              </div>
              <div v-else>未绑定</div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryLogo"
            label="状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.workingState == 'yes'" class="success"
                >在职</span
              >
              <span v-else class="danger">离职</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="allEmployeeList.total"
          @current-change="pagingEmployee"
          @size-change="handleSizeChangeEmployee"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPageEmployee"
        ></el-pagination>
      </div>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="keep">确 定</el-button>
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog
      :close-on-click-modal="false"
      title="批量设置"
      :visible.sync="dialogVisiblEemployee"
    >
      <div class="table-panel flex flex-end">
        <div>
          <el-input
            style="width:249px"
            size="small"
            type="text"
            placeholder="请输入导购账号/名称"
            class="mr10"
            v-model.trim="keyWords"
          ></el-input>
          <el-button type="primary" size="small" @click="searchGuider"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mb10">
        <div class="tips mb20">提示：点击表格行即可选择</div>
        <el-table
          @current-change="getCheckedEmployee"
          :data="allEmployeeList.records"
          highlight-current-row
          style="width: 100%"
          stripe
          size="small"
          border
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentEmployeePage - 1) * 10 + 1"
          ></el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            label="用户账号"
            prop="username"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realname"
            label="用户名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryLogo"
            label="状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.workingState == 'yes'" class="success"
                >在职</span
              >
              <span v-else class="danger">离职</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="allEmployeeList.total"
            @current-change="pagingEmployee"
            @size-change="handleSizeEmployeeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentEmployeePage"
          ></el-pagination>
        </div>
      </div>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="saveEemployee">确 定</el-button>
        <el-button size="small" @click="dialogVisiblEemployee = false">取 消</el-button>
      </div>
    </el-dialog> -->

    <el-dialog
      :close-on-click-modal="false"
      title="导表分配/解绑导购"
      :visible.sync="allotrDialogVisible"
    >
      <div>
        <el-form label-width="100px">
          <el-form-item label="分配/解绑">
            <el-radio-group v-model="allotrParams.operation">
              <el-radio label="binding">分配导购</el-radio>
              <el-radio label="UnBundling">解绑导购</el-radio>
            </el-radio-group>
            <div class="flex flex-wrap">
              <el-button
                style="marginleft: 24px; marginright: 48px; font-size: 14px"
                class="blue"
                size="small"
                @click="outputExcel"
                type="text"
                >导出模板</el-button
              >
              <div class="delete mr20 pointer open-file blue">
                <!-- <span class="delete-icon hmicon icon-daoru"></span> -->
                导入表格
                <input
                  type="file"
                  @change="importf"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="info" @click="allotrDialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column
            header-align="center"
            align="center"
            prop="specBarcode"
            label="无效信息"
          >
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      title="客户优惠券"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="couponDialogVisible"
    >
      <div class="mb20">
        <el-radio-group
          size="small"
          v-model="isPlus"
          @change="queryCustomerCoupon"
          class="mb10"
        >
          <el-radio :label="1">全部</el-radio>
          <el-radio :label="0">PLUS</el-radio>
        </el-radio-group>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="可用券" name="valid"></el-tab-pane>
          <el-tab-pane label="失效券" name="invalid"></el-tab-pane>
        </el-tabs>
        <template v-if="activeName === 'valid'">
          <el-radio-group
            size="small"
            v-model="useRank"
            @change="switchCouponState"
          >
            <el-radio-button
              v-for="(v, i) in navList"
              :key="i"
              :label="v.useRank"
              >{{ v.text }}</el-radio-button
            >
          </el-radio-group>
        </template>
        <template v-if="activeName === 'invalid'">
          <el-radio-group
            size="small"
            v-model="couponState"
            @change="switchCouponState"
          >
            <el-radio-button
              v-for="(v, i) in validCouponNavList"
              :key="i"
              :label="v.couponState"
              >{{ v.text }}</el-radio-button
            >
          </el-radio-group>
        </template>
      </div>
      <el-table
        stripe
        border
        ref="brandTable"
        :data="couponList"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="
            (index) => index + (couponCurrentPage - 1) * couponPageSize + 1
          "
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="券名"
          prop="name"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="券额">
          <template slot-scope="scope">
            <span v-if="scope.row.account">￥{{ scope.row.account }}</span>
            <span v-if="scope.row.discount">{{ scope.row.discount }}折</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="使用门槛">
          <template slot-scope="scope"> ￥{{ scope.row.levelMin }} </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="过期时间"
          prop="endDate"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="备注"
          prop="ruleRemark"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="couponTotal"
          @current-change="couponPaging"
          @size-change="handleCouponSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="couponCurrentPage"
          :page-size="couponPageSize"
        ></el-pagination>
      </div>
      <div class="flex flex-center">
        <el-button size="small" @click="couponDialogVisible = false"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
    <hm-import-temp
      :tHeader="tHeader"
      :tBody="tBody"
      @close="importTempVisible = false"
      @importSuccess="importSuccess"
      title="会员导入"
      filterText="memberMobile"
      :visible="importTempVisible"
    ></hm-import-temp>
    <el-dialog
      title="会员变更记录"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="changeRecordVisible"
    >
      <div class="mb10 flex flex-end">
        <el-input v-model="searchConditionChange.memberMobile" size="small" placeholder="请输入会员手机号/姓名"  clearable class="mr10" style="width: 200px"></el-input>
        <el-select
          clearable
          class="mr10"
          style="width: 200px"
          size="small"
          v-model="searchConditionChange.operationType"
          placeholder="请选择"
          filterable
        >
          <el-option label="批量解绑导购" value="batchUnBinding"></el-option>
          <el-option label="批量分配导购" value="batchBinding"></el-option>
          <el-option label="指定导购" value="appointGuider"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="searchChange"
          >查询</el-button
        >
      </div>
      <el-table
        stripe
        border
        ref="brandTable"
        :data="changeRecordList"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="
            (index) => index + (changeCurrentPage - 1) * changePageSize + 1
          "
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="会员名称"
          prop="memberName"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          label="会员手机号"
          prop="memberMobile"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="变更前归属导购"
          prop="beforeReferName"
          width="249"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.beforeReferName"
                >{{ scope.row.beforeReferDepartName }}
                {{ scope.row.beforeReferDepartName ? "-" : "" }}
                {{ scope.row.beforeReferName }}</span
              >
              <div v-if="scope.row.beforeReferWorkNum">
                导购工号:{{ scope.row.beforeReferWorkNum }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="变更后归属导购"
          prop="afterReferName"
          width="249"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.afterReferName"
                >{{ scope.row.afterReferDepartName }}
                {{ scope.row.afterReferDepartName ? "-" : "" }}
                {{ scope.row.afterReferName }}</span
              >
              <div v-if="scope.row.afterReferWorkNum">
                导购工号:{{ scope.row.afterReferWorkNum }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="变更方式"
          prop="ruleRemark"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.operationType === 'batchUnBinding'">
              批量解绑导购
            </div>
            <div v-else-if="scope.row.operationType === 'batchBinding'">
              批量分配导购
            </div>
            <div v-else-if="scope.row.operationType === 'appointGuider'">
              指定导购
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="变更时间"
          prop="operationTime"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作人"
          prop="operationName"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="changeTotal"
          @current-change="changePaging"
          @size-change="handleSizeChangeMember"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="changeCurrentPage"
          :page-size="changePageSize"
        ></el-pagination>
      </div>
    </el-dialog>
    <!-- <hm-member-details
      :visible="detailsModalVisible"
      @close="detailsModalVisible = false"
      :centerId="centerId"
    >
    </hm-member-details> -->
    <el-dialog
      :close-on-click-modal="false"
      title="金豆明细"
      :visible.sync="dialogVisibleJinDou"
      width="1000px"
    >
      <el-dialog
        :close-on-click-modal="false"
        title="调整金豆"
        :visible.sync="dialogVisibleEditJindou"
        width="500px"
        append-to-body
      >
        <div class="flex flex-center">
          <div class="text-center">
            <el-radio-group v-model="operateType">
              <el-radio label="add">新增</el-radio>
              <el-radio label="sub">扣减</el-radio>
            </el-radio-group>
            <div class="mt20">
              <el-input
                clearable
                v-model.trim="operateNum"
                placeholder="请输入金豆数"
                size="small"
                class="ipt"
              ></el-input>
              <div class="text-left">
                可用调整
                <span class="primary">{{
                  adjustJindouRow.goldBeanAmountBalance
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="btn-wrapper flex flex-center" slot="footer">
          <el-button size="small" type="primary" @click="editJinDou"
            >确 认</el-button
          >
          <el-button
            @click="dialogVisibleEditJindou = false"
            size="small"
            type="info"
            >取 消</el-button
          >
        </div>
      </el-dialog>
      <el-radio-group
        class="mb10"
        size="small"
        v-model="detailType"
        @change="detailTypeChange"
      >
        <el-radio-button label="data">金豆数据</el-radio-button>
        <el-radio-button label="biangeng">变更记录</el-radio-button>
      </el-radio-group>
      <div v-if="detailType === 'data'">
        <el-table
          :data="detailList"
          style="width: 100%"
          stripe
          size="small"
          border
          ref="jindoutable"
          max-height="500px"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="金豆别称"
            prop="ruleName"
          ></el-table-column>
          <el-table-column header-align="center" align="center" label="有效期" width="300">
            <template slot-scope="scope">
              {{ scope.row.startTime }} - {{ scope.row.endTime }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="金豆值"
            prop="goldBeanAmountBalance"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="useStatus"
            label="金豆状态"
          >
            <template slot-scope="scope">
              <div :class="scope.row.useStatus === 'yes' ? 'success' : 'danger'">
                {{ scope.row.useStatus === "yes" ? "开启" : "作废" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="adjustJindou(scope.row)"
              >
                调整金豆
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else>
        <!-- <div class="mb10 flex flex-end">
          <el-select
            clearable
            v-model="searchConditionDialog.shopId"
            placeholder="请选金豆别称"
            size="small"
            filterable
            class="mr10"
          >
            <el-option
              :label="v.shopName"
              :value="v.shopId"
              v-for="(v, i) in shopList"
              :key="i"
            ></el-option>
          </el-select>
          <el-select
            clearable
            v-model="searchConditionDialog.shopIds"
            placeholder="请选择变更操作"
            size="small"
            filterable
            class="mr10"
          >
            <el-option
              :label="v.shopName"
              :value="v.shopId"
              v-for="(v, i) in shopList"
              :key="i"
            ></el-option>
          </el-select>
          <el-input
            clearable
            v-model.trim="searchConditionDialog.keyWords"
            placeholder="请输入订单号"
            size="small"
            class="ipt mr10"
          >
          </el-input>
          <el-button type="primary" size="small" @click="searchDetail"
            >查询</el-button
          >
        </div> -->
        <el-table
          :data="detailList"
          style="width: 100%"
          stripe
          size="small"
          border
          ref="jindoutable"
          max-height="500px"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="
              (index) => index + (currentPageDetail - 1) * pageSizeDetail + 1
            "
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="变更操作"
            key="bizType"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.bizType === 'orderOffline'">
                线下下单获取
                <el-popover
                  placement="bottom"
                  width="200"
                  trigger="click"
                  :content="scope.row.content"
                >
                  <div slot="reference" class="blue pointer">获取名称</div>
                </el-popover>
              </div>
              <div v-else-if="scope.row.bizType === 'orderOnline'">
                线上下单获取
                <el-popover
                  placement="bottom"
                  width="200"
                  trigger="click"
                  :content="scope.row.content"
                >
                  <div slot="reference" class="blue pointer">获取名称</div>
                </el-popover>
              </div>
              <div v-else-if="scope.row.bizType === 'used'">购买消耗</div>
              <div v-else-if="scope.row.bizType === 'orderRefund'">
                线上订单退款返还
              </div>
              <div v-else-if="scope.row.bizType === 'orderOfflineRefund'">
                线下订单退款扣减
              </div>
              <div v-else-if="scope.row.bizType === 'orderTimeOut'">
                订单超时返还
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="交易订单号"
            prop="fromOrder"
          ></el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            label="金豆别称"
            prop="ruleName"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="金豆变化"
            key="goldBeanAmount"
          >
            <template slot-scope="scope">
              <span> {{ scope.row.tradeModel === "in" ? "+ " : "- " }}</span>
              {{ scope.row.goldBeanAmount }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="变更时间"
            key="createTime"
          >
            <template slot-scope="scope">
              <span> {{ scope.row.createTime }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalDetail"
            @current-change="pagingDetail"
            @size-change="handleSizeChangeDetail"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPageDetail"
          ></el-pagination>
        </div>
      </div>

      <div class="btn-wrapper flex flex-center" slot="footer">
        <el-button size="small" @click="dialogVisibleJinDou = false"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import HmImportTemp from "@/components/HmImportTemp";
// import HmMemberDetails from "@/components/HmMemberDetails";
import { setCookie, getCookie } from "@/utils/utils";
import { arrayUnique2 } from "@/utils/utils";
import { getLoginUser } from "@/utils/auth";
import moment from "moment";

import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    HmImportTemp,
    // HmMemberDetails
  },
  data() {
    return {
      storeCode: "",
      detailList: [],
      shopList: [],
      searchConditionDialog: {},
      dialogVisibleJinDou: false,
      couponTotal: 0,
      activeName: "valid",
      couponDialogVisible: false,
      allotrParams: {
        operation: "binding",
      },
      errValidGoods: false,
      errInputResult: [],
      allotrDialogVisible: false,
      innerVisible: false,
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "store",
              })
              .then((res) => {
                res.result.records.forEach((v) => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.orgCode;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "store",
              })
              .then((res) => {
                if (res.code === "0" && res.result) {
                  res.result.forEach((v) => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      tHeader: ["会员名称（必填）", "会员手机号"],
      tBody: ["memberName", "memberMobile"],
      importTempVisible: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      dueDatepickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() < Date.now() ||
            time.getTime() > Date.now() + 280 * 8.64e7
          );
        },
      },
      dynamicTags: ["标签一", "标签二", "标签三"],
      setMemberDialogVisible: false,
      dialogVisible: false,
      inputVisible: false,
      showFamilyCase: false,
      detailsModalVisible: false,
      setMemberIdDialogVisible: false,
      inputValue: "",
      num: 0,
      keyWords: "",
      searchCondition: {
        queryType: "memberMobile",
        date: [],
        openDate: [],
        isShareMember: "",
        isFriend: "",
      },
      couponPageSize: 10,
      checkedRow: {},
      ruleForm: {
        memberMobile: "",
        memberName: "",
        memberSex: "male",
        memberBirthday: "",
        memberRemark: "",
        dueDate: "",
        familyInfo: [
          {
            familyBirthday: "",
            familyName: "",
            familyRelation: "",
          },
        ],
      },
      rules: {
        memberMobile: {
          required: true,
          pattern: /^1[0-9]{10}$/,
          message: "请输入正确的手机号",
          trigger: "blur",
        },
        memberName: [
          {
            required: true,
            message: "请输入会员姓名",
            trigger: "blur",
          },
          {
            required: true,
            min: 1,
            max: 20,
            message: "字数限制1-20之间",
            trigger: "blur",
          },
        ],
      },
      show: false,
      title: "添加会员",
      mode: "add",
      keyword: "",
      level: 0,
      parentCategoryId: "",
      parentCategoryName: "",
      tagModalVisible: false,
      dialogVisiblEemployee: false,
      categoryName: "",
      currentRow: {},
      tableData1: [],
      currentPage: 1,
      pageSize: 10,
      useRank: 0,
      couponState: "",
      validCouponNavList: [
        {
          couponState: "notExpired",
          text: "已使用",
          loadingType: "more",
          couponList: [],
        },
        {
          couponState: "expired",
          text: "已过期",
          loadingType: "more",
          couponList: [],
        },
        {
          couponState: "freeze",
          text: "冻结中",
          loadingType: "more",
          couponList: [],
        },
      ],
      navList: [
        {
          useRank: 0,
          text: "通用券",
          loadingType: "more",
          couponList: [],
        },
        {
          useRank: 2,
          text: "门店券",
          loadingType: "more",
          couponList: [],
        },
        {
          useRank: 1,
          text: "线上券",
          loadingType: "more",
          couponList: [],
        },
      ],
      couponList: [],
      currentEmployeePage: 1,
      couponCurrentPage: 1,
      pageEmployeeSize: 10,
      currentPageEmployee: 1,
      pageSizeEmployee: 10,
      createTimeStart: "",
      createTimeEnd: "",
      isHaveMemberCard: "",
      defaultCardId: "",
      centerId: "",
      detMemberMgt: {
        storeMemberCenterInfoVo: [],
        cardInfoVoList: [],
        familyInfoVoList: [],
        labelInfoVos: [],
      },
      detailMember: [],
      checkedEmployee: "",
      isOutputing: false,
      cardId: "",
      allEmployee: [],
      placeholder: "请输入手机号",
      allLabelList: [],
      labelId: "",
      row: {},
      changeRecordList: [],
      changeTotal: 0,
      changeCurrentPage: 1,
      changePageSize: 10,
      changeRecordVisible: false,
      changeMemberMobile: "",
      searchConditionChange: {},
      detailType: "data",
      totalDetail: 0,
      currentPageDetail: 1,
      pageSizeDetail: 10,
      totalGoldBeanAmount: 0,
      transactionStatistics: [],
      dialogVisibleEditJindou: false,
      operateType: "add",
      operateNum: "",
      adjustJindouRow: {},
      time: "",
      timer: "",
      authCode: "",
      memberRecord: [],
      isPlus: 1,
    };
  },
  computed: mapGetters([
    "memberMgtList",
    "allEmployeeList",
    "allMemberMgtList",
  ]),
  watch: {
    // "memberMgtList.total": {
    //   handler(val) {
    //     if (
    //       val == (this.currentPage - 1) * this.pageSize &&
    //       this.pageTotal != 0
    //     ) {
    //       this.currentPage -= 1;
    //       this.queryList();
    //     }
    //   },
    //   deep: true
    // }
  },
  created() {},
  mounted() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    console.log("this.storeCode:",this.storeCode);
    this.searchCondition.date = [
      moment(new Date()).format("YYYY-MM-DD") + " 00:00:00",
      moment(new Date()).format("YYYY-MM-DD") + " 23:59:59",
    ];

    this.getParamsCookie();
    if (this.$route.query.time) {
      this.searchCondition.date = JSON.parse(this.$route.query.time);
      if (this.$route.query.isShareMember) {
        this.searchCondition.isShareMember = "yes";
      } else {
        this.searchCondition.isShareMember = "";
      }
    }
    this.queryList();
    this.queryAllEmployeeList();
  },
  methods: {
      isBtn(code) {
      return this.isShowBtn(code);
    },
    adjustJindou(row) {
      this.operateType = "add";
      this.operateNum = "";
      this.adjustJindouRow = row;
      this.dialogVisibleEditJindou = true;
    },
    async editJinDou() {
      if (!this.operateNum) {
        this.$message({
          message: "请输入金豆数",
          type: "warning",
        });
        return;
      }
      await this.$store.dispatch("applyUpdateMemberGoldBeanNum", {
        centerId: this.adjustJindouRow.centerId,
        operateType: this.operateType,
        operateNum: this.operateNum,
        ruleId: this.adjustJindouRow.ruleId,
      });
      this.$message({
        message: "操作成功！",
        type: "success",
      });
      this.dialogVisibleEditJindou = false;
      this.queryDetailList();
    },
    detailTypeChange() {
      this.detailList = [];
      this.currentPageDetail = 1;
      this.pageSizeDetail = 10;
      this.queryDetailList();
      // this.$nextTick(() => {
      //   //解决表头与内容错位
      //   this.$refs.jindoutable.doLayout();
      // });
    },
    searchDetail() {
      this.currentPageDetail = 1;
      this.queryDetailList();
    },
    async queryDetailList() {
      const params = {
        centerId: this.centerId,
        pageSize: this.pageSizeDetail,
        pageNo: this.currentPageDetail,
      };
      const searchCondition = JSON.parse(
        JSON.stringify(this.searchConditionDialog)
      );
      Object.assign(params, searchCondition);
      let name =
        this.detailType === "data"
          ? "memberGoldBeanInfo"
          : "memberGoldBeanFlow";
      const { code, result } = await this.$store.dispatch(name, params);
      if (code === "0") {
        if (this.detailType === "data") {
          const { totalGoldBeanAmount, memberGoldBeanInfo } = result;
          this.totalGoldBeanAmount = totalGoldBeanAmount;
          this.detailList = memberGoldBeanInfo;
        } else {
          const { total, records } = result;
          records.forEach((v) => {
            v.content =
              v.sendName + (v.specialName ? "(" + v.specialName + ")" : "");
          });
          this.detailList = records;
          console.log("this.detailList: ", this.detailList);
          this.totalDetail = total;
        }
      }
    },
    pagingDetail(page) {
      this.currentPageDetail = page;
      this.queryDetailList();
    },
    handleSizeChangeDetail(size) {
      this.currentPageDetail = 1;
      this.pageSizeDetail = size;
      this.queryDetailList();
    },
    handleClick() {
      this.couponList = [];
      this.couponCurrentPage = 1;
      if (this.activeName === "valid") {
        this.useRank = 0;
        this.queryCustomerCoupon();
      } else {
        this.couponState = "notExpired";
        this.queryCustomerCoupon();
      }
    },
    switchCouponState() {
      this.couponCurrentPage = 1;
      this.queryCustomerCoupon();
    },
    viewCustomerCoupon() {
      this.activeName = "valid";
      this.useRank = 0;
      this.queryCustomerCoupon();
      this.couponDialogVisible = true;
    },
    viewCustomerJinDou() {
      this.detailType = "data";
      this.dialogVisibleJinDou = true;
      this.currentPageDetail = 1;
      this.pageSizeDetail = 10;
      this.queryDetailList();
    },
    async queryCustomerCoupon() {
      const { storeCode } = getLoginUser();
      const params = {
        memberCenterId: this.centerId,
        storeCode,
        pageSize: this.couponPageSize,
        pageNo: this.couponCurrentPage,
        isPlus: this.isPlus,
      };
      if (this.activeName === "valid") {
        Object.assign(params, {
          type: "notexpired",
          status: "4",
          useRank: this.useRank,
        });
      } else {
        if (this.couponState === "notExpired") {
          Object.assign(params, {
            status: "2",
            type: null,
          });
        } else if (this.couponState === "expired") {
          Object.assign(params, {
            status: null,
            type: "expired",
          });
        } else if (this.couponState === "freeze") {
          Object.assign(params, {
            status: 5,
            type: null,
          });
        }
      }
      const { result } = await this.$store.dispatch(
        "queryCustomerCoupon",
        params
      );
      const { page } = result;
      const { records, total } = page;
      this.couponTotal = total;
      const couponList = records;
      couponList.filter((item) => {
        if (
          item.ruleStartDate &&
          item.ruleEndDate &&
          item.ruleStartTime &&
          item.ruleEndTime
        ) {
          item.dateTime =
            item.ruleStartDate +
            " " +
            item.ruleStartTime.split(",")[0] +
            "至" +
            item.ruleEndDate +
            " " +
            item.ruleEndTime.split(",")[0];
          item.endTime =
            item.ruleEndDate + " " + item.ruleEndTime.split(",")[0];
        } else {
          item.dateTime = "";
        }
      });
      this.couponList = couponList;
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        let tHeader = [];
        if (this.allotrParams.operation === "binding") {
          tHeader = ["会员手机号", "导购工号", "导购手机号"];
        } else {
          tHeader = ["会员手机号"];
        }

        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        let name =
          this.allotrParams.operation === "binding"
            ? "分配导购模板"
            : "解绑导购模板";
        exportJsonToExcel(tHeader, data, name);
      });
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let memberEmployeeModels = [];
        let errList = [];
        let isRequired = false;
        let isPhone = false;
        if (that.allotrParams.operation === "binding") {
          result.forEach((v) => {
            // if (v[0]) {
            //   goodsSns.push(v[0]);
            // }
            if (!v[0] || !v[1] || !v[2]) {
              isRequired = true;
            } else {
              memberEmployeeModels.push({
                memberMobile: v[0],
                workNum: v[1],
                employeeMemberMobile: v[2],
              });
              // if (/^1[3-9]\d{9}$/.test(v[0]) && /^1[3-9]\d{9}$/.test(v[2])) {
              //   memberEmployeeModels.push({
              //     memberMobile: v[0],
              //     workNum: v[1],
              //     employeeMemberMobile: v[2]
              //   });
              // } else {
              //   errList.push(!/^1[3-9]\d{9}$/.test(v[0]) ? v[0] : v[2]);
              //   isPhone = true;
              // }
            }
          });
        } else {
          // result.forEach(v => {
          //   // if (v[0]) {
          //   //   goodsSns.push(v[0]);
          //   // }
          //   if (!v[0]) {
          //     isRequired = true;
          //   } else {
          //     if (/^1[3-9]\d{9}$/.test(v[0])) {
          //       memberEmployeeModels.push({
          //         memberMobile: v[0]
          //       });
          //     } else {
          //       errList.push(v[0]);
          //       //     that.errValidGoods = true;
          //       //     that.errInputResult = result.errGoodsSnsAndSpecBarcode;
          //       isPhone = true;
          //     }
          //   }
          // });
        }
        if (isRequired) {
          that.$message({
            message: "导入失败，请导入完整导购信息！",
            type: "warning",
          });
        } else {
          if (isPhone) {
            that.errValidGoods = true;
            that.errInputResult = errList;
            that.$message({
              message: "导入失败，请填写正确手机号！",
              type: "warning",
            });
          } else {
            memberEmployeeModels = arrayUnique2(
              memberEmployeeModels,
              "memberMobile"
            );
            let params = {
              memberEmployeeModels,
              operation: that.allotrParams.operation,
            };
            that.$store.dispatch("batchAllotr", params).then((res) => {
              const { code, result } = res;

              if (code === "0") {
                that.allotrDialogVisible = false;
                that.allotrParams.operation = "binding";
                // if (result.modelList.length > 0) {
                //   result.modelList.forEach(v => {
                //     v.bargainTotalStockSum = "";
                //     v.eachPurchaseLimit = "";
                //     v.integralValue = "";
                //   });
                //   that.rule.push(...result.modelList);
                //   that.rule = arrayUnique2(that.rule, "wxshopSkuId");
                //   that.$forceUpdate();
                // }
                that.queryList();

                if (result.length > 0) {
                  that.errValidGoods = true;
                  that.errInputResult = result;
                }
              }
            });
          }
        }

        // goodsSns = unique(goodsSns);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    batchAllot() {
      this.allotrDialogVisible = true;
    },
    async saveLabel() {
      if (this.labelId !== "") {
        const { code } = await this.$store.dispatch("addLabelToCenter", {
          labelId: this.labelId,
          centerId: this.centerId,
        });
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.$store
            .dispatch("detailsMemberMgt", {
              centerId: this.centerId,
            })
            .then((res) => {
              if (res.code == "0") {
                this.labelId = "";
                this.detMemberMgt = res.result;
                res.result.cardInfoVoList.forEach((v) => {
                  if (v.isMasterCard == "yes") {
                    this.defaultCardId = v.memberCardId;
                  }
                });
              }
            });
          this.innerVisible = false;
        }
      } else {
        this.$message({
          message: "请选择会员标签",
          type: "warning",
        });
      }
    },
    async addLabel() {
      this.innerVisible = true;
    },
    selectQueryType(queryType) {
      if (queryType === "memberMobile") {
        this.placeholder = "请输入手机号";
      } else if (queryType === "memberName") {
        this.placeholder = "请输入会员名称";
      } else if (queryType === "cardNo") {
        this.placeholder = "请输入会员卡号";
      }
    },
    async queryAllEmployeeList() {
      const { result } = await this.$store.dispatch("queryEmployeeList", {
        pageNo: 1,
        pageSize: 9999,
        workingState: "yes",
        loginType: "store",
      });
      this.allEmployee = result.records;
    },
    queryEmployeeList() {
      this.$store.dispatch("queryEmployeeList", {
        pageNo: this.currentPageEmployee,
        pageSize: this.pageSizeEmployee,
        workingState: "yes",
        queryKey: this.keyWords,
        loginType: "store",
      });
    },
    addFamilyCase() {
      this.showFamilyCase = true;
    },
    deleteDute() {
      this.showFamilyCase = false;
      this.ruleForm.familyInfo = [
        {
          familyBirthday: "",
          familyName: "",
          familyRelation: "",
        },
      ];
    },
    deleteBabyCase(i) {
      this.ruleForm.familyInfo.splice(i, i);
    },
    addBaby() {
      this.ruleForm.familyInfo.push({
        familyBirthday: "",
        familyName: "",
        familyRelation: "",
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.ruleForm;

          this.$store.dispatch("addMemberMgt", params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.setMemberDialogVisible = false;
              this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    async handleTagClose(tag, index) {
      const { code } = await this.$store.dispatch("delCenterLabel", {
        relId: tag.relId,
        labelId: tag.labelId,
        centerId: this.centerId,
      });
      if (code === "0") {
        this.detMemberMgt.labelInfoVos.splice(index, 1);
      }
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    importSuccess(memberList) {
      this.$store.dispatch("batchAddmember", memberList).then((res) => {
        if (res.code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success",
          });
          this.importTempVisible = false;
          this.queryList();
        }
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    viewMemberCard(row) {
      this.setMemberIdDialogVisible = true;
      this.$store
        .dispatch("detailMemberId", {
          memberMobile: row.memberMobile,
        })
        .then((res) => {
          if (res.code == "0") {
            this.detailMember = res.result;
          }
        });
    },
    async toDetails(row) {
      this.mode = "edit";
      this.centerId = row.centerId;
      this.row = row;
      await this.queryDetailList();
      this.detailsModalVisible = true;
      const { result } = await this.$store.dispatch("queryAllLabel", {
        centerId: row.centerId,
      });
      this.allLabelList = result;
      this.$store
        .dispatch("detailsMemberMgt", {
          centerId: row.centerId,
        })
        .then((res) => {
          if (res.code == "0") {
            this.detMemberMgt = res.result;
            this.detMemberMgt.storeMemberCenterInfoVo.isFriend =
              this.row.isFriend;
            res.result.cardInfoVoList.forEach((v) => {
              if (v.isMasterCard == "yes") {
                this.defaultCardId = v.memberCardId;
              }
            });
            res.result.transactionStatistics.lastShoppingTime =
              res.result.storeMemberCenterInfoVo.lastShoppingTime;
            this.transactionStatistics = [];
            this.transactionStatistics.push(res.result.transactionStatistics);
            this.query_member_record();
          }
        });
    },
    getChecked(selection) {
      this.checkedRow = selection.map((v) => v.spuId);
      this.centerId = selection.map((v) => v.centerId);
      this.num = selection.length;
    },
    moveTo(row) {
      this.$router.push({
        name: "GoodsList",
        query: {
          categoryId: row.categoryId,
        },
      });
    },
    batchSetting() {
      if (this.checkedRow.length) {
        this.dialogVisible = true;
        this.queryEmployeeList();
      } else {
        this.$message({
          message: "请选择批量项",
          type: "warning",
        });
      }
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    handleSizeChangeEmployee(size) {
      this.currentPageEmployee = 1;
      this.pageSizeEmployee = size;
      this.queryEmployeeList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    couponPaging(page) {
      this.couponCurrentPage = page;
      this.queryCustomerCoupon();
    },
    handleCouponSizeChange(size) {
      this.couponCurrentPage = 1;
      this.couponPageSize = size;
      this.queryCustomerCoupon();
    },
    pagingEmployee(page) {
      this.currentPageEmployee = page;
      this.queryEmployeeList();
    },
    switchLevel() {
      this.ruleForm.categoryId = [];
    },
    queryAllList() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.createTimeStart =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";
      searchCondition.createTimeEnd =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[1]
          : "";
      searchCondition.opencardTimeStart =
        this.searchCondition.openDate &&
        this.searchCondition.openDate.length > 0
          ? this.searchCondition.openDate[0]
          : "";
      searchCondition.opencardTimeEnd =
        this.searchCondition.openDate &&
        this.searchCondition.openDate.length > 0
          ? this.searchCondition.openDate[1]
          : "";

      if (typeof searchCondition.orgCode == "object") {
        searchCondition.orgCode =
          searchCondition.orgCode[searchCondition.orgCode.length - 1];
      }
      // let params = {
      //   pageSize: 999999,
      //   pageNo: 1
      // };
      // Object.assign(params, searchCondition);
      searchCondition.pageSize = 999999;
      searchCondition.pageNo = 1;

      return this.$store.dispatch("queryAllMemberMgtList", searchCondition);
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.createTimeStart =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";
      searchCondition.createTimeEnd =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[1]
          : "";
      searchCondition.opencardTimeStart =
        this.searchCondition.openDate &&
        this.searchCondition.openDate.length > 0
          ? this.searchCondition.openDate[0]
          : "";
      searchCondition.opencardTimeEnd =
        this.searchCondition.openDate &&
        this.searchCondition.openDate.length > 0
          ? this.searchCondition.openDate[1]
          : "";
      if (typeof searchCondition.orgCode == "object") {
        searchCondition.orgCode =
          searchCondition.orgCode[searchCondition.orgCode.length - 1];
      }

      Object.assign(params, searchCondition);
      this.setParamsCookie();
      return this.$store.dispatch("queryMemberMgtList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "memberMgtParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        }),
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "memberMgtParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    cropUploadSuccess(jsonData) {
      this.ruleForm.categoryLogo = jsonData.result;
    },
    changePaging(page) {
      this.changeCurrentPage = page;
      this.queryStoreMemberReferChangeRecordList();
    },
    handleSizeChangeMember(size) {
      this.changeCurrentPage = 1;
      this.changePageSize = size;
      this.queryStoreMemberReferChangeRecordList();
    },
    async queryStoreMemberReferChangeRecordList() {
      let params = {
        pageSize: this.changePageSize,
        pageNo: this.changeCurrentPage,
      };
      const searchCondition = JSON.parse(
        JSON.stringify(this.searchConditionChange)
      );
      Object.assign(params, searchCondition);
      const { result, code } = await this.$store.dispatch(
        "queryStoreMemberReferChangeRecordList",
        params
      );
      if (code === "0") {
        const { records, total } = result;
        this.changeRecordList = records;
        this.changeTotal = total;
      }
    },
    changeRecord() {
      this.changeCurrentPage = 1;
      this.changePageSize = 10;
      this.changeRecordVisible = true;
      this.queryStoreMemberReferChangeRecordList();
    },
    addMember() {
      this.mode === "add";
      this.setMemberDialogVisible = true;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    addChild(row) {
      this.mode = "addChild";
      this.title = "新增子类目";
      this.currentRow = row;
      this.tagModalVisible = true;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
      this.ruleForm.level = "child";
      this.ruleForm.categoryId = [this.currentRow.categoryId];
      this.level = +this.currentRow.categoryLevel + 1;
    },
    edit(row) {
      this.mode = "edit";
      this.title = "编辑类目";
      this.currentRow = row;
      this.tagModalVisible = true;
      this.$store
        .dispatch("queryGoodsCategoryDetails", {
          categoryId: this.currentRow.categoryId,
        })
        .then((res) => {
          this.ruleForm.level =
            +this.currentRow.categoryLevel > 1 ? "child" : "parent";
          this.ruleForm.categoryName = this.currentRow.categoryName;
          this.ruleForm.categoryLogo = this.currentRow.categoryLogo;
          this.ruleForm.categoryId = [res.result.parentCategoryId];
          this.parentCategoryName = res.result.parentCategoryName || "";
          setTimeout(() => {
            if (this.$refs.cascader) {
              this.$refs.cascader.inputValue = this.parentCategoryName;
            }
          }, 0);
        });
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.parentCategoryName = "";
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store
          .dispatch("deleteGoodsCategory", {
            categoryId: row.categoryId,
          })
          .then((res) => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success",
              });
              this.$store.commit("QUERY_GOOD_CATEGORY_LIST", {
                result: { record: [] },
              });
              this.queryList();
            }
          });
      });
    },
    logout() {
      this.$confirm(" 是否确定注销?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          centerId: this.centerId,
          memberMobile: this.row.memberMobile,
        };

        this.$store.dispatch("memberCancel", params).then((res) => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success",
            });
            this.detailsModalVisible = false;
            this.queryList();
          }
        });
      });
    },
    async removeMember() {
      const memberMobile = this.detMemberMgt.storeMemberCenterInfoVo.memberMobile;
      this.$confirm(
        "确定要删除该会员吗？删除后会员在所有关联表中的数据将被永久清除，此操作不可逆！",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          const res = await this.$store.dispatch("removeMemberByMobile", {
            memberMobile,
          });
          if (res.code === "0") {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.detailsModalVisible = false;
            this.queryList();
          } else {
            this.$message({
              message: res.errMsg || "删除失败",
              type: "error",
            });
          }
        })
        .catch(() => {});
    },
    save() {
      let params = {
        defaultCardId: this.defaultCardId,
        centerId: this.centerId,
      };

      let actionName = "";
      if (this.mode === "add" || this.mode === "addChild") {
        actionName = "addGoodsCategory";
      } else if (this.mode === "edit") {
        actionName = "editMemberMgt";
      }

      this.$store.dispatch(actionName, params).then((res) => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.detailsModalVisible = false;
          this.queryList();
        }
      });

      // this.$refs.ruleForm.validate(valid => {
      //   if (valid) {
      //     // const categoryLevel =
      //     //   this.ruleForm.level === "parent" ? "1" : this.level;

      //     let actionName = "";
      //     if (this.mode === "add" || this.mode === "addChild") {
      //       actionName = "addGoodsCategory";
      //     } else if (this.mode === "edit") {
      //       params = Object.assign(params, {
      //         categoryId: this.currentRow.categoryId
      //       });
      //       actionName = "editGoodsCategory";
      // }
      // this.$store.dispatch(actionName, params).then(res => {
      //   if (res.code === "0") {
      //     this.$message({
      //       message: "操作成功",
      //       type: "success"
      //     });
      //     this.tagModalVisible = false;

      //     this.$store.commit("QUERY_GOOD_CATEGORY_LIST", {
      //       result: { record: [] }
      //     });
      //     this.queryList();
      //   }
      // });
      // } else {
      //   return false;
      // }
      // });
    },
    searchChange() {
      this.changeCurrentPage = 1;
      this.queryStoreMemberReferChangeRecordList();
    },
    search() {
      // this.createTimeStart =
      //   this.searchCondition.date && this.searchCondition.date.length > 0
      //     ? this.searchCondition.date[0]
      //     : "";
      // this.createTimeEnd =
      //   this.searchCondition.date && this.searchCondition.date.length > 0
      //     ? this.searchCondition.date[0]
      //     : "";

      this.currentPage = 1;
      this.queryList();
    },
    searchGuider() {
      this.currentEmployeePage = 1;
      this.queryEmployeeList();
    },
    // saveEemployee() {
    //   let params = {};
    //   params.belongEmployeeId = this.checkedEmployee;
    //   params.memberCardIds = this.checkedRow;
    //   this.$store.dispatch("batchAllocation", params).then(res => {
    //     if (res.code == 0) {
    //       this.dialogVisible = false;
    //       this.queryList();
    //     }
    //   });
    // },
    handleSizeEmployeeChange(size) {
      this.currentEmployeePage = 1;
      this.pageEmployeeSize = size;
      this.queryEmployeeList();
    },
    getEmployee(row) {
      this.dialogVisible = true;
      this.centerId = row.centerId;
      this.queryEmployeeList();
    },
    getCheckedEmployee(selection) {
      this.checkedEmployee = selection.employeeId;
    },
    memberDataMove() {
      let phone = this.changeMemberMobile;
      let params = {
        centerId: this.centerId,
        mobile: this.changeMemberMobile,
        smgCode: this.authCode,
      };
      console.log(
        "旧手机号:",
        this.detMemberMgt.storeMemberCenterInfoVo.memberMobile
      );
      console.log("新手机号", phone);
      console.log("this.centerId:", this.centerId);
      if (!phone) {
        this.$message({
          message: " 请输入手机号",
          type: "warning",
        });
        return;
      }
      if (!/^1[0-9]{10}$/.test(phone)) {
        this.$message({
          message: " 请输入正确的手机号",
          type: "warning",
        });
        return;
      }
      this.$store.dispatch("memberDataMove", params).then((res) => {
        if (res.code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success",
          });
          this.changeMemberMobile = "";
          this.authCode = "";
          this.detailsModalVisible = false;
          this.queryList();
        }
      });
    },
    async getCode() {
      const { storeCode } = getLoginUser();
      let params = {
        memberMobile: this.detMemberMgt.storeMemberCenterInfoVo.memberMobile,
        storeCode,
      };
      this.$store.dispatch("sendCode", params).then((res) => {
        if (res.code === "0") {
          this.$message({
            message: " 发送成功",
            type: "success",
          });
          let time = 61;
          time--;
          this.time = time;
          this.timer = setInterval(() => {
            if (time > 1) {
              time--;
              this.time = time;
            } else {
              this.time = "";
              clearInterval(this.timer);
            }
          }, 1000);
        }
      });
    },
    async query_member_record() {
      let params = {
        mobile: this.detMemberMgt.storeMemberCenterInfoVo.memberMobile,
      };
      this.$store.dispatch("query_member_record", params).then((res) => {
        if (res.result) {
          this.memberRecord = res.result;
          console.log("this.memberRecord:", this.memberRecord);
        }
      });
    },
    keep() {
      let params = {};
      params.employeeId = this.checkedEmployee;
      params.centerIds = this.isArray(this.centerId)
        ? this.centerId
        : [this.centerId];

      this.$store.dispatch("batchAllocation", params).then((res) => {
        if (res.code == 0) {
          this.dialogVisible = false;
          this.queryList();
        }
      });
    },
    // 导出excel
    async output() {
      /*require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(res => {
            const list = res.result.records;

            list.forEach(v => {
              if (v.defaultCardId == "-") {
                v.defaultCardId = "否";
              } else {
                v.defaultCardId = "是";
                v.card = "关联会员卡";
              }
              if (v.sourceType == "manual") {
                v.sourceType = "手工";
              } else if (v.sourceType == "synchro") {
                v.sourceType = "同步";
              } else if (v.sourceType == "fans") {
                v.sourceType = "粉丝";
              }
              if (v.fansId) {
                v.fansId = "是";
              } else {
                v.fansId = "否";
              }
              if (v.isShareMember === "yes") {
                v.isShareMember = "是";
              } else {
                v.isShareMember = "否";
              }
              if (!v.wechatCode) {
                v.wechatCode = "邀请关注";
              }
              if (!v.shopName || !v.realName) {
                v.guide = `${v.shopName || ""}${v.realName || ""}`;
              } else {
                v.guide = v.shopName + "-" + v.realName;
              }
            });

            const tHeader = [
              "会员手机号",
              "客户姓名",
              "来源方式",
              "标签",
              "是否关联会员卡",
              "关联会员卡",
              "是否粉丝",
              "是否推会员",
              "微信编号",
              "注册时间",
              "开卡时间",
              "归属导购",
              "导购工号"
            ];
            const filterVal = [
              "memberMobile",
              "memberName",
              "sourceType",
              "seqNum",
              "defaultCardId",
              "card",
              "fansId",
              "isShareMember",
              "wechatCode",
              "createTime",
              "opencardTime",
              "guide",
              "workNum"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "会员管理" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });*/
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.createTimeStart =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";
      searchCondition.createTimeEnd =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[1]
          : "";
      searchCondition.opencardTimeStart =
        this.searchCondition.openDate &&
        this.searchCondition.openDate.length > 0
          ? this.searchCondition.openDate[0]
          : "";
      searchCondition.opencardTimeEnd =
        this.searchCondition.openDate &&
        this.searchCondition.openDate.length > 0
          ? this.searchCondition.openDate[1]
          : "";
      if (typeof searchCondition.orgCode == "object") {
        searchCondition.orgCode =
          searchCondition.orgCode[searchCondition.orgCode.length - 1];
      }

      console.log("searchParam  =======", searchCondition);
      await this.$store.dispatch("memberListExport", searchCondition);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.$refs.hmcontent.flag = false;
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.logo {
  width: 80px;
}
.info-list {
  .title {
    margin-bottom: 20px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.cardid {
  margin-top: 23px;
}
.line {
  width: 1px;
  height: 40px;
  background: #ddd;
  margin: 0 80px;
}
.get-code {
  margin: 0 10px;
  width: 80px;
  cursor: pointer;
}
</style>
